export default __webpack_public_path__ + "static/hom-foundation-3dd9cf8a283ed52c33109a8dd7e044ab.svg";